import { render, staticRenderFns } from "./SystemMessageTable.vue?vue&type=template&id=2ad65e82"
import script from "./SystemMessageTable.vue?vue&type=script&lang=js"
export * from "./SystemMessageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports